export { default as UserList } from './UserList';
export { default as UserEdit } from './UserEdit';
export { default as UserPasswordChange } from './UserPasswordChange';
export { default as UserCreate } from './UserCreate';



// WEBPACK FOOTER //
// ./src/modules/user/pages/index.js